(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    event.preventDefault();
  });

  function readProductSettingsJSON(root) {
    if (!root) return null;
    const scripts = root.querySelectorAll('script[type="application/json"]');
    for (const s of scripts) {
      for (const attr of Array.from(s.attributes)) {
        if (attr.name.startsWith('data-product-settings-')) {
          return JSON.parse(s.textContent || '{}');
        }
      }
    }
    return null;
  }

  document.addEventListener('product-form:message:success', (event) => {
    const sectionEl = event.detail.form.closest('.shopify-section');
    const settings = readProductSettingsJSON(sectionEl) || {};
    if (settings && typeof settings.successMessage === 'string') {
      const title = event.detail.response?.title ?? event.detail.response?.product_title ?? '';
      event.detail.message = settings.successMessage.replace('** product **', title);
    }

    console.log(event.detail);

    if (event.detail.cart && typeof event.detail.cart.item_count === 'number') {
      document.dispatchEvent(new CustomEvent('cart:count', { detail: { count: event.detail.cart.item_count } }));
    }
  });

  } catch(e) { console.error(e); }
})();
})();
